import * as $ from 'jquery';
import { OnReadyModule } from '../../lib/app-module';
import { getPosts, JekyllResource, renderJekyllResourcesAppend } from '../../lib/jekyll-resources';


export interface PostLoaderConfig {
    initialIndex: number;
    templateSelector: string;
    containerSelector: string;
    loadMoreButtonSelector: string;
    version: string;
}

interface PostLoaderExport {
    load: (count: number) => Promise<void>;
}

export class PostLoader extends OnReadyModule<PostLoaderConfig, PostLoaderExport> {
    protected init(): void {
        this.currentIndex = this.config.initialIndex;
    }
    protected override preload(): void {
        this._export = {load: (count: number) => (this.loadMore(count))};
    }

    private currentIndex: number;
    private posts: JekyllResource[];

    private async loadMore(count: number): Promise<void> {
        const [from, to] = this.getNewRange(count);
        const posts =  await getPosts(this.config.version);
        const selectedPosts = posts.slice(from, to);
        renderJekyllResourcesAppend(selectedPosts, this.config.templateSelector, this.config.containerSelector);
        this.maybeHideLoadButton(posts.length);
    }

    private getNewRange(count:  number):  [number, number] {
        const from = this.currentIndex;
        this.currentIndex += count;
        return [from, this.currentIndex];
    }

    private maybeHideLoadButton(postsCount: number): void {
        if (this.currentIndex >= postsCount) {
            $(this.config.loadMoreButtonSelector).hide();
        }
    }
}